let debugMode = false;

function setDebugMode(enabled) {
  debugMode = !!enabled;
}

function log(...args) {
  if (debugMode) console.log(...args);
}

function warn(...args) {
  console.warn(...args);
}

function error(...args) {
  console.error(...args);
}

export { setDebugMode, log, warn, error };